<template>
  <vs-tabs>
    <vs-tab label="Senin" icon-pack="feather" icon="icon-calendar">
      <vs-table :data="monday">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Waktu Mulai</vs-th>
          <vs-th>Waktu Selesai</vs-th>
          <vs-th>Kapasitas</vs-th>
          <vs-th>Pilihan</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">{{ indextr }}</vs-td>
            <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
            <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
            <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-button
                  @click="$router.push({name: 'agencies-services-cluster-edit', 
                          params : {id : $route.params.id, service_id: $route.params.service_id, cluster_id : tr.id}})"
                  type="border"
                  color="primary"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-edit"
                >Edit Cluster</vs-button>
                <vs-button
                  @click="deleteCluster(tr.id)"
                  type="border"
                  color="danger"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-trash"
                >Hapus Cluster</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> 
    </vs-tab>
    <vs-tab label="Selasa" icon-pack="feather" icon="icon-calendar">
      <vs-table :data="tuesday">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Waktu Mulai</vs-th>
          <vs-th>Waktu Selesai</vs-th>
          <vs-th>Kapasitas</vs-th>
          <vs-th>Pilihan</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">{{ indextr }}</vs-td>
            <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
            <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
            <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-button
                  @click="$router.push({name: 'agencies-services-cluster-edit', 
                          params : {id : $route.params.id, service_id: $route.params.service_id, cluster_id : tr.id}})"
                  type="border"
                  color="primary"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-edit"
                >Edit Cluster</vs-button>
                <vs-button
                  @click="deleteCluster(tr.id)"
                  type="border"
                  color="danger"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-trash"
                >Hapus Cluster</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> 
    </vs-tab>
    <vs-tab label="Rabu" icon-pack="feather" icon="icon-calendar">
      <vs-table :data="wednesday">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Waktu Mulai</vs-th>
          <vs-th>Waktu Selesai</vs-th>
          <vs-th>Kapasitas</vs-th>
          <vs-th>Pilihan</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">{{ indextr }}</vs-td>
            <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
            <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
            <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-button
                  @click="$router.push({name: 'agencies-services-cluster-edit', 
                          params : {id : $route.params.id, service_id: $route.params.service_id, cluster_id : tr.id}})"
                  type="border"
                  color="primary"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-edit"
                >Edit Cluster</vs-button>
                <vs-button
                  @click="deleteCluster(tr.id)"
                  type="border"
                  color="danger"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-trash"
                >Hapus Cluster</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> 
    </vs-tab>
    <vs-tab label="Kamis" icon-pack="feather" icon="icon-calendar">
      <vs-table :data="thursday">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Waktu Mulai</vs-th>
          <vs-th>Waktu Selesai</vs-th>
          <vs-th>Kapasitas</vs-th>
          <vs-th>Pilihan</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">{{ indextr }}</vs-td>
            <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
            <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
            <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-button
                  @click="$router.push({name: 'agencies-services-cluster-edit', 
                          params : {id : $route.params.id, service_id: $route.params.service_id, cluster_id : tr.id}})"
                  type="border"
                  color="primary"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-edit"
                >Edit Cluster</vs-button>
                <vs-button
                  @click="deleteCluster(tr.id)"
                  type="border"
                  color="danger"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-trash"
                >Hapus Cluster</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> 
    </vs-tab>
    <vs-tab label="Jumat" icon-pack="feather" icon="icon-calendar">
      <vs-table :data="friday">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th>Waktu Mulai</vs-th>
          <vs-th>Waktu Selesai</vs-th>
          <vs-th>Kapasitas</vs-th>
          <vs-th>Pilihan</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
            <vs-td :data="indextr">{{ indextr }}</vs-td>
            <vs-td :data="tr.start_time">{{ tr.start_time }}</vs-td>
            <vs-td :data="tr.end_time">{{ tr.end_time }}</vs-td>
            <vs-td :data="tr.capacity">{{ tr.capacity }}</vs-td>
            <vs-td>
              <div class="vx-row">
                <vs-button
                  @click="$router.push({name: 'agencies-services-cluster-edit', 
                          params : {id : $route.params.id, service_id: $route.params.service_id, cluster_id : tr.id}})"
                  type="border"
                  color="primary"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-edit"
                >Edit Cluster</vs-button>
                <vs-button
                  @click="deleteCluster(tr.id)"
                  type="border"
                  color="danger"
                  size="small"
                  class="m-1"
                  icon-pack="feather"
                  icon="icon-trash"
                >Hapus Cluster</vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table> 
    </vs-tab>
  </vs-tabs>
</template>

<script>
export default {
  props: {
    clusters: {
      type: Array,
      required:true
    }
  },  
  computed:{
    monday(){
      return this.clusters.filter(function (item){
        return item.workday == 1;
      });
    },
    tuesday(){
      return this.clusters.filter(function (item){
        return item.workday == 2;
      });
    },
    wednesday(){
      return this.clusters.filter(function (item){
        return item.workday == 3;
      });
    },
    thursday(){
      return this.clusters.filter(function (item){
        return item.workday == 4;
      });
    },
    friday(){
      return this.clusters.filter(function (item){
        return item.workday == 5;
      });
    },
  },
  methods: {
    deleteCluster(clusterId){
      this.$emit('deleteCluster', clusterId);
    },
  }
};
</script>